import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EpaySetting } from '../interfaces/epay-setting';
import { MessageBoxService, Result } from './message-box.service';

@Injectable({
  providedIn: 'root'
})
export class EpayService {

  epaySettings: EpaySetting[] = [
    {index: 1, name: "merchantnumber", value: "8033377", type:"input"},
    {index: 2, name: "currency", value: "DKK", type:"input"},
    {index: 3, name: "instantcapture", value: "1", type:"input"},
    {index: 4, name: "windowstate", value: "3", type:"input"},
    {index: 5, name: "accepturl", value: "http://dev-tilmelding.ollerup.dk/%LANG%/public/payment/success", type:"input"},
    {index: 6, name: "cancelurl", value: "http://dev-tilmelding.ollerup.dk/%LANG%/public/payment/cancel", type:"input"},
    {index: 7, name: "callbackurl", value: "http://dev-webapi.ollerup.dk/order/epay", type:"input"},
  ];

//SUBSCRIBTION EPAY PARAMETRE
private epaySource = new BehaviorSubject<EpaySetting[]>([]);
epay$: Observable<EpaySetting[]> = this.epaySource.asObservable();

constructor(private _http: HttpClient, private _msgBox: MessageBoxService) {
  //this.epaySource.next(this.epaySettings);
  
  this._http.get<EpaySetting[]>('admin/settings/epay').subscribe( result => {
      this.epaySource.next(result)   
  }, (error:HttpErrorResponse )=> {
      console.log(error.message);
  });
 }

 saveEpaySettings(settings: EpaySetting[]){
   this._http.patch('admin/settings/epay/edit', settings).subscribe( (result: Result) => {
      this._msgBox.createMessageboxSuccess(result.message);
   }, (error:HttpErrorResponse )=> {
    this._msgBox.createMessageboxError(error.message);
   });
 }
}
